{
  "matchGroups": {
    "adult_gaming_centre": [
      "amenity/casino",
      "amenity/gambling",
      "leisure/adult_gaming_centre"
    ],
    "beauty": [
      "shop/beauty",
      "shop/hairdresser_supply"
    ],
    "bed": [
      "shop/bed",
      "shop/furniture"
    ],
    "beverages": [
      "shop/alcohol",
      "shop/beer",
      "shop/beverages",
      "shop/kiosk",
      "shop/wine"
    ],
    "camping": [
      "tourism/camp_site",
      "tourism/caravan_site"
    ],
    "car_parts": [
      "shop/car_parts",
      "shop/car_repair",
      "shop/tires",
      "shop/tyres"
    ],
    "clinic": [
      "amenity/clinic",
      "amenity/doctors",
      "healthcare/clinic",
      "healthcare/laboratory",
      "healthcare/physiotherapist",
      "healthcare/sample_collection",
      "healthcare/dialysis"
    ],
    "convenience": [
      "shop/beauty",
      "shop/chemist",
      "shop/convenience",
      "shop/cosmetics",
      "shop/grocery",
      "shop/kiosk",
      "shop/newsagent",
      "shop/perfumery"
    ],
    "coworking": [
      "amenity/coworking_space",
      "office/coworking",
      "office/coworking_space"
    ],
    "dentist": [
      "amenity/dentist",
      "amenity/doctors",
      "healthcare/dentist"
    ],
    "electronics": [
      "office/telecommunication",
      "shop/computer",
      "shop/electronics",
      "shop/hifi",
      "shop/kiosk",
      "shop/mobile",
      "shop/mobile_phone",
      "shop/telecommunication"
    ],
    "fabric": [
      "shop/fabric",
      "shop/haberdashery",
      "shop/sewing"
    ],
    "fashion": [
      "shop/accessories",
      "shop/bag",
      "shop/boutique",
      "shop/clothes",
      "shop/department_store",
      "shop/fashion",
      "shop/fashion_accessories",
      "shop/sports",
      "shop/shoes"
    ],
    "financial": [
      "amenity/bank",
      "office/accountant",
      "office/financial",
      "office/financial_advisor",
      "office/tax_advisor",
      "shop/tax"
    ],
    "fitness": [
      "leisure/fitness_centre",
      "leisure/fitness_center",
      "leisure/sports_centre",
      "leisure/sports_center"
    ],
    "food": [
      "amenity/bar",
      "amenity/cafe",
      "amenity/fast_food",
      "amenity/ice_cream",
      "amenity/pub",
      "amenity/restaurant",
      "shop/bakery",
      "shop/candy",
      "shop/chocolate",
      "shop/coffee",
      "shop/confectionary",
      "shop/confectionery",
      "shop/food",
      "shop/kiosk",
      "shop/ice_cream",
      "shop/pastry",
      "shop/tea"
    ],
    "fuel": [
      "amenity/fuel",
      "shop/gas",
      "shop/convenience;gas",
      "shop/gas;convenience"
    ],
    "gift": [
      "shop/gift",
      "shop/card",
      "shop/cards",
      "shop/kiosk",
      "shop/stationery"
    ],
    "hardware": [
      "shop/bathroom_furnishing",
      "shop/carpet",
      "shop/diy",
      "shop/doityourself",
      "shop/doors",
      "shop/electrical",
      "shop/flooring",
      "shop/hardware",
      "shop/hardware_store",
      "shop/power_tools",
      "shop/tool_hire",
      "shop/tools",
      "shop/trade"
    ],
    "health_food": [
      "shop/health",
      "shop/health_food",
      "shop/herbalist",
      "shop/nutrition_supplements"
    ],
    "hobby": [
      "shop/electronics",
      "shop/hobby",
      "shop/books",
      "shop/games",
      "shop/collector",
      "shop/toys",
      "shop/model",
      "shop/video_games",
      "shop/anime"
    ],
    "hospital": [
      "amenity/doctors",
      "amenity/hospital",
      "healthcare/hospital"
    ],
    "houseware": [
      "shop/houseware",
      "shop/interior_decoration"
    ],
    "lifeboat_station": [
      "amenity/lifeboat_station",
      "emergency/lifeboat_station",
      "emergency/marine_rescue"
    ],
    "lodging": [
      "tourism/hotel",
      "tourism/motel"
    ],
    "money_transfer": [
      "amenity/money_transfer",
      "shop/money_transfer"
    ],
    "office_supplies": [
      "shop/office_supplies",
      "shop/stationary",
      "shop/stationery"
    ],
    "outdoor": [
      "shop/clothes",
      "shop/outdoor",
      "shop/sports"
    ],
    "parcel_locker": [
      "amenity/parcel_locker",
      "amenity/vending_machine"
    ],
    "pharmacy": [
      "amenity/doctors",
      "amenity/pharmacy",
      "healthcare/pharmacy"
    ],
    "playground": [
      "amenity/theme_park",
      "leisure/amusement_arcade",
      "leisure/playground"
    ],
    "rental": [
      "amenity/bicycle_rental",
      "amenity/boat_rental",
      "amenity/car_rental",
      "amenity/truck_rental",
      "amenity/vehicle_rental",
      "shop/kiosk",
      "shop/rental"
    ],
    "school": [
      "amenity/childcare",
      "amenity/college",
      "amenity/kindergarten",
      "amenity/language_school",
      "amenity/prep_school",
      "amenity/school",
      "amenity/university"
    ],
    "storage": [
      "shop/storage_units",
      "shop/storage_rental"
    ],
    "substation": [
      "power/station",
      "power/substation",
      "power/sub_station"
    ],
    "supermarket": [
      "shop/food",
      "shop/frozen_food",
      "shop/greengrocer",
      "shop/grocery",
      "shop/supermarket",
      "shop/wholesale"
    ],
    "variety_store": [
      "shop/variety_store",
      "shop/discount",
      "shop/convenience"
    ],
    "vending": [
      "amenity/vending_machine",
      "shop/kiosk",
      "shop/vending_machine"
    ],
    "weight_loss": [
      "amenity/clinic",
      "amenity/doctors",
      "amenity/weight_clinic",
      "healthcare/counselling",
      "leisure/fitness_centre",
      "office/therapist",
      "shop/beauty",
      "shop/diet",
      "shop/food",
      "shop/health_food",
      "shop/herbalist",
      "shop/nutrition",
      "shop/nutrition_supplements",
      "shop/weight_loss"
    ],
    "wholesale": [
      "shop/wholesale",
      "shop/supermarket",
      "shop/department_store"
    ]
  }
}
